import { getToken } from 'firebase/messaging';
import { messaging } from './firebaseMessaging';
import { apiService } from '../../constants/ApiService';

export const registerFCMToken = async () => {
  try {
    const permission = await Notification.requestPermission();

    if (permission !== 'granted') {
      console.log('Notification permission denied');
      return;
    }

    const token = await getToken(messaging, {
      vapidKey:
        'BEUie2yaRkQcfMyvecJH775k4fARVY0LiFKGmjOWCYST_mjmrZxswiV1FcCGDYUnnPAMyFSHrmshDxYJor2W-sk',
    });

    if (token) {
      const body = {
        Token: token,
        Platform: 'WEB',
      };
      await apiService.post('api/Notification/save-token', body);
    }
  } catch (err) {
    console.error('FCM error:', err);
  }
};
//heena
// import { getToken } from 'firebase/messaging';
// import { messaging } from './firebaseMessaging';
// import { apiService } from '../../constants/ApiService';

// const FCM_TOKEN_KEY = 'saved_fcm_token';

// export const registerFCMToken = async () => {
//   try {
//     const token = await getToken(messaging, {
//       vapidKey:
//         'BEUie2yaRkQcfMyvecJH775k4fARVY0LiFKGmjOWCYST_mjmrZxswiV1FcCGDYUnnPAMyFSHrmshDxYJor2W-sk',
//     });

//     if (!token) {
//       console.log('FCM token not found');
//       return;
//     }

//     const normalizedToken = token.trim();
//     const alreadySavedToken = localStorage.getItem(FCM_TOKEN_KEY);

//     if (alreadySavedToken === normalizedToken) {
//       console.log('FCM token already saved, skipping API call');
//       return;
//     }

//     const body = {
//       Token: normalizedToken,
//       Platform: 'WEB',
//     };

//     await apiService.post('api/Notification/save-token', body);

//     localStorage.setItem(FCM_TOKEN_KEY, normalizedToken);

//     console.log('FCM token saved successfully');
//   } catch (err) {
//     console.error('FCM error:', err);
//   }
// };
